<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-700px w-full">

    <section class="p-3 border-b border-gray-800">
      <div class="flex justify-between">
        <div class="flex">
          <h4 class="text-white text-sm font-bold uppercase mb-3">Create Provider</h4>
          <span v-for="error in getErrors('create_provider')"
          class="ml-5 mt-2 text-red-600">{{ error }}</span>
        </div>
        <button type="button" class="close" @click.prevent="toggleModal"><span>×</span></button>
      </div>
    </section>

    <div class="flex lang-box pt-2">
        <a v-for="(lang, index) in languages" href="#" @click.prevent="changeLanguage(lang)" :key="index"
        :class="{active:(form.current_language == lang)}">{{ lang }}</a>
    </div>

    <div class="flex p-2">
      <div class="w-1/3 p-2 border-gray-800 border-r">
        <label for="">Logo</label>
          <div class="upload-box">
              <span>
                  <i class="icon-upload mr-2"></i><a href="##">Upload from media library</a>
              </span>
          </div>
      </div>
      <div class="w-2/3 p-2">
        <label for="name">Provider name</label>
        <input type="text" class="input-black" @change="handleChange"
        :value="getCurrentInput()">

        <button @click="createProvider" class="btn btn-gradient mt-2 mb-2 float-right">
            <i class="icon-arrow-right mr-2"></i>Create provider
        </button>

      </div>

    </div>

    </div>
  </div>
</div>
</template>

<script>
import { getErrors } from '@/Pages/GlobalHelpers';

export default {
  props: ['showModal', 'toggleModal'],
  data(){
    return{
      languages: this.$page.props.languages,
      form: this.$inertia.form({
          _method: 'POST',
          newProviderData: this.makeNewProviderData(),
          current_language: null,
      })
    }
  },
  methods: {
    getErrors:getErrors,
    changeLanguage(lang){
      this.form.current_language = lang;
    },
    createProvider(){
      this.form.post(route('provider.store'), {
        onSuccess: () => {
          this.toggleModal();
        },
        onError: (err) => {}
      });
    },
    makeNewProviderData(){
      let arr = [];
      this.$page.props.languages.map(lang => {
        arr.push({
          lang: lang,
          name: null
        });
      })
      return arr;
    },
    getCurrentInput(){
      return this.form.newProviderData.filter(el => el.lang == this.form.current_language).length &&
      this.form.newProviderData.filter(el => el.lang == this.form.current_language)[0].name
    },
    handleChange(e){
      this.form.newProviderData.filter(el => el.lang == this.form.current_language)[0].name = e.target.value;
    }
  },
  mounted(){
    this.changeLanguage(this.$page.props.languages[0])
  }
}
</script>